export const moneyFormat =
  localStorage.getItem('i18nextLng') === 'pt-br' ? { thousand: '.', decimal: ',' } : { thousand: ',', decimal: '.' }

export const thousandsSeparator = (value: number) =>
  new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true
  }).format(value)

export const DECIMALS_MONEY = {
  default: 2,
  BHD: 3
}
